import { useQuery } from "@tanstack/react-query";
import { fetchClient } from "@/lib/api-client";

export const useFetchLatestSellerVerification = (
  options: { enabled?: boolean } = {},
) => {
  const { enabled = true } = options;

  const queryFn = async () => {
    const response = await fetchClient.GET("/seller-verification/me", {});
    if (response.error) throw response.error;
    return response.data;
  };

  const { data, error, isLoading, isFetching, refetch } = useQuery({
    queryKey: ["seller-verification", "me"],
    queryFn,
    enabled,
  });

  return {
    data,
    error,
    isLoading,
    isFetching,
    refetch,
  };
};
